export enum ServiceId {
    WEB_APP = "WEB_APP",
    NATIVE_APP = "NATIVE_APP",
    NATIVE_APP_IOS = "NATIVE_APP_IOS",
    NATIVE_APP_ANDROID = "NATIVE_APP_ANDROID",
    LANDING = "LANDING",
    HOME = "HOME",
    STUDIO = "STUDIO",
    CREATOR = "CREATOR",
    TURBO = "TURBO",
    DREAMHACK_APP = "DREAMHACK_APP"
}
